import React, { useEffect, useState } from "react";
import { Container, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/images/logo.png";
import { VERIFY_EMAIL } from "../api/constants";

const verifyRequestCache = new Map();

const verifyEmailToken = async (token) => {
  if (verifyRequestCache.has(token)) {
    return verifyRequestCache.get(token);
  }

  const request = (async () => {
    try {
      const response = await fetch(
        `${VERIFY_EMAIL}?token=${encodeURIComponent(token)}`,
        {
          method: "GET",
        },
      );

      const data = await response.json();
      const isSuccess = data?.status === true;
      const apiText = [data?.title, data?.message, data?.error, data?.errors]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      if (isSuccess) return "success";
      if (apiText.includes("already verified") || apiText.includes("already")) {
        return "already";
      }

      return "failed";
    } catch (error) {
      console.error("Email verification failed:", error);
      return "failed";
    }
  })();

  verifyRequestCache.set(token, request);
  return request;
};

function Verify() {
  const navigate = useNavigate();
  const [message, setMessage] = useState("Verifying your email...");

  useEffect(() => {
    let isMounted = true;

    const verifyEmail = async () => {
      const params = new URLSearchParams(window.location.search);
      const token = params.get("token");

      if (!token) {
        navigate("/sign-in?verified=missing", { replace: true });
        return;
      }

      const result = await verifyEmailToken(token);
      if (!isMounted) return;

      if (result === "success") {
        setMessage("Email verified successfully. Redirecting to sign in...");
        navigate("/sign-in?verified=success", { replace: true });
        return;
      }

      if (result === "already") {
        navigate("/sign-in?verified=already", { replace: true });
        return;
      }

      navigate("/sign-in?verified=failed", { replace: true });
    };

    verifyEmail();

    return () => {
      isMounted = false;
    };
  }, [navigate]);

  return (
    <div className="login-sign-main common-padding">
      <Container>
        <Card>
          <div className="login-sign-wrap">
            <img src={Logo} alt="" />
            <h3 className="mb-3">Verifying Email</h3>
            <p className="mt-0">{message}</p>
          </div>
        </Card>
      </Container>
    </div>
  );
}

export default Verify;
